<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 id="toc_marker-3">Preface to the Third Edition</h2>
<p class="veryfirst">The third edition adds two chapters. One considers whether economics is a science or an art and examines from a biblical perspective why this is even an issue of contention. The other evidences the advances made in relieving global poverty and the effectiveness of “top down” compared to “bottom up” development. All the data in all the remaining chapters has been updated and the latest topical research incorporated, as well as the few spiritual insights God has granted me since the publication of the previous edition. As before, hopefully the book remains current, accurate and balanced.</p>
<p class="body"></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface.vue?54db2d2b